/**
 * Sign-up forms (newsletter, subscriptions…) — one submit handler for every module.
 *
 * A module declares its form in window.PdSignupForms (its script loads before this one):
 *   (window.PdSignupForms = window.PdSignupForms || []).push({
 *       formClass: 'pd-nl-form',             // form.<formClass> — also matches imported HTML
 *       css: 'pd-nl',                        // message box: .<css>__msg, --ok / --err
 *       endpoint: '/api/newsletter/subscribe',
 *       label: 'Palladium.Newsletter'        // console prefix
 *   });
 *
 * Document-level delegation: the ONLY mechanism that works on statically rendered pages (no Blazor
 * circuit, so no handler set by the component). Payload: email, consent, culture, page/node ids,
 * honeypot, plus fullName when the form has input[name=fullname] and lists when it has data-lists.
 * Texts come from the form's data-* attributes (consent error, success message, loading label).
 */
(function () {
    function config(formEl) {
        var list = window.PdSignupForms || [];
        for (var i = 0; i < list.length; i++)
            if (formEl.classList.contains(list[i].formClass)) return list[i];
        return null;
    }

    function feedback(formEl, css, msg, ok) {
        var box = formEl.querySelector('.' + css + '__msg');
        if (!box) {
            box = document.createElement('div');
            formEl.appendChild(box);
        }
        box.textContent = msg;
        box.className = css + '__msg ' + css + '__msg--' + (ok ? 'ok' : 'err');
    }

    function submit(formEl, cfg) {
        if (!formEl.checkValidity()) { formEl.reportValidity(); return; }

        var q = function (sel) { return formEl.querySelector(sel); };
        var emailEl = q('input[type="email"]');
        var nameEl = q('input[name="fullname"]');
        var consentEl = q('input[type="checkbox"][data-consent]');
        var hpEl = q('input[name="_pd_hp"]');
        var btn = q('button[type="submit"]');

        var payload = {
            email: emailEl ? emailEl.value : '',
            // No checkbox shown = consent carried by the block's text (the server still requires the flag).
            consent: consentEl ? consentEl.checked : true,
            culture: formEl.getAttribute('data-culture') || '',
            pageContentItemId: formEl.getAttribute('data-page-id') || '',
            nodeId: formEl.getAttribute('data-node-id') || '',
            hp: hpEl ? hpEl.value : ''
        };
        if (nameEl) payload.fullName = nameEl.value;
        if (formEl.hasAttribute('data-lists')) payload.lists = formEl.getAttribute('data-lists') || '';

        // Adresse plausible (domaine avec un point et une extension) : « test@te » partait au serveur (retour Babylone 20/10/2026).
        var emailVal = (emailEl ? emailEl.value : '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/.test(emailVal)) {
            feedback(formEl, cfg.css, formEl.getAttribute('data-email-error') || 'Indiquez une adresse e-mail valide (ex. prenom@domaine.fr).', false);
            if (emailEl) emailEl.focus();
            return;
        }
        if (consentEl && !consentEl.checked) {
            feedback(formEl, cfg.css, formEl.getAttribute('data-consent-error') || 'Merci de cocher la case de consentement.', false);
            return;
        }

        var originalLabel = '';
        if (btn) {
            originalLabel = btn.innerHTML;
            btn.innerHTML = btn.getAttribute('data-loading-text') || '…';
            btn.disabled = true;
        }

        fetch(cfg.endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify(payload)
        })
            .then(function (res) {
                return res.json()
                    .catch(function () { return {}; })
                    .then(function (body) { return { ok: res.ok, body: body }; });
            })
            .then(function (r) {
                if (r.ok && r.body.success) {
                    var redirect = formEl.getAttribute('data-redirect-url');
                    if (redirect) { window.location.href = redirect; return; }
                    var success = formEl.getAttribute('data-success-message') || r.body.message;
                    formEl.innerHTML = '<div class="' + cfg.css + '__msg ' + cfg.css + '__msg--ok">' + '✓ ' + success + '</div>';
                } else {
                    feedback(formEl, cfg.css, r.body.error || 'Erreur lors de l’inscription.', false);
                }
            })
            .catch(function (err) {
                console.error('[' + (cfg.label || 'Palladium') + '] signup error:', err);
                feedback(formEl, cfg.css, 'Erreur de connexion. Veuillez réessayer.', false);
            })
            .finally(function () {
                if (btn && formEl.contains(btn)) {
                    btn.innerHTML = originalLabel;
                    btn.disabled = false;
                }
            });
    }

    document.addEventListener('submit', function (e) {
        var form = e.target;
        if (form.tagName !== 'FORM') return;
        var cfg = config(form);
        if (!cfg) return;
        e.preventDefault();
        submit(form, cfg);
    });
})();
